import { render } from "./Pendientes.vue?vue&type=template&id=119b3e18&scoped=true"
import script from "./Pendientes.vue?vue&type=script&lang=js"
export * from "./Pendientes.vue?vue&type=script&lang=js"

import "./Pendientes.vue?vue&type=style&index=0&id=119b3e18&scoped=true&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119b3e18"]])

export default __exports__